import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  jobDate: {
    id: 'sosSubForm.towingOrderForm.jobDate',
    defaultMessage: 'Työn pvm',
  },
  time: {
    id: 'sosSubForm.towingOrderForm.time',
    defaultMessage: 'Aika',
  },
  endTime: {
    id: 'sosSubForm.towingOrderForm.endTime',
    defaultMessage: 'Lopetusaika',
  },
  caseNumber: {
    id: 'sosSubForm.towingOrderForm.caseNumber',
    defaultMessage: 'SOS Viite',
  },
  insuranceCompany: {
    id: 'sosSubForm.towingOrderForm.insuranceCompany',
    defaultMessage: 'Vakuutusyhtiö',
  },
  estimatedServiceType: {
    id: 'sosSubForm.towingOrderForm.estimatedServiceType',
    defaultMessage: 'Arvioitu toimenpide',
  },
  estimatedCause: {
    id: 'sosSubForm.towingOrderForm.estimatedCause',
    defaultMessage: 'Arvioitu vika',
  },
  additionalInfo: {
    id: 'sosSubForm.towingOrderForm.additionalInfo',
    defaultMessage: 'Työn lisätiedot',
  },
  notes: {
    id: 'sosSubForm.towingOrderForm.notes',
    defaultMessage: 'Muistiinpanot',
  },
  situationDescription: {
    id: 'sosSubForm.towingOrderForm.situationDescription',
    defaultMessage: 'SOS Merkinnät',
  },
})
